// @catalog F.030
// DrawerTabs — Barra de 5 pestañas del ProductDetailDrawer.
// Extraído del orchestrator para mantener P7 (<=500 líneas).

import { Box, Stack, Tab, Tabs } from "@mui/material";

export type TabKey = "resumen" | "tiendas" | "historico" | "catalogo" | "sistema";

interface DrawerTabsProps {
  value: TabKey;
  onChange: (key: TabKey) => void;
  tiendasCount: number | null;
  historicoCount: number | null;
  catalogoCount: number | null;
}

function CountBadge({
  count,
  active,
}: {
  count: number;
  active: boolean;
}) {
  return (
    <Box
      component="span"
      sx={{
        fontSize: 10.5,
        bgcolor: active ? "var(--accent-soft)" : "var(--bg-2)",
        color: active ? "var(--accent)" : "var(--ink-3)",
        px: 0.625,
        borderRadius: 0.5,
        fontWeight: 600,
        minWidth: 16,
        textAlign: "center",
      }}
    >
      {count}
    </Box>
  );
}

export function DrawerTabs({
  value,
  onChange,
  tiendasCount,
  historicoCount,
  catalogoCount,
}: DrawerTabsProps) {
  return (
    <Box
      sx={{
        px: 2.5,
        bgcolor: "var(--surface)",
        borderTop: "1px solid var(--border)",
        borderBottom: "1px solid var(--border)",
        flexShrink: 0,
      }}
    >
      <Tabs
        value={value}
        onChange={(_, v: TabKey) => onChange(v)}
        variant="scrollable"
        scrollButtons={false}
        sx={{
          minHeight: 42,
          "& .MuiTabs-indicator": {
            height: 2,
            bgcolor: "var(--accent)",
          },
          "& .MuiTab-root": {
            textTransform: "none",
            fontSize: 13,
            fontWeight: 500,
            color: "var(--ink-3)",
            minHeight: 42,
            px: 1.75,
            py: 1.25,
            minWidth: "auto",
            "&.Mui-selected": {
              color: "var(--ink-1)",
            },
          },
        }}
      >
        <Tab value="resumen" label="Resumen" />
        <Tab
          value="tiendas"
          label={
            <Stack direction="row" spacing={0.75} alignItems="center">
              <span>Por tienda</span>
              {tiendasCount != null && (
                <CountBadge
                  count={tiendasCount}
                  active={value === "tiendas"}
                />
              )}
            </Stack>
          }
        />
        <Tab
          value="historico"
          label={
            <Stack direction="row" spacing={0.75} alignItems="center">
              <span>Histórico</span>
              {historicoCount != null && (
                <CountBadge
                  count={historicoCount}
                  active={value === "historico"}
                />
              )}
            </Stack>
          }
        />
        <Tab
          value="catalogo"
          label={
            <Stack direction="row" spacing={0.75} alignItems="center">
              <span>Catálogo</span>
              {catalogoCount != null && (
                <CountBadge
                  count={catalogoCount}
                  active={value === "catalogo"}
                />
              )}
            </Stack>
          }
        />
        <Tab value="sistema" label="Sistema" />
      </Tabs>
    </Box>
  );
}
